var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgDesktopLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 351,
    height: 348,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#54E596",
    d: "M140.583 268.61c-5.215-8.22-10.71-17.103-12.46-29.483-4.781-33.822 3.612-82.323 51.894-70.67 16.59 2.685 20.648 31.982 26.323 43.488 6.531 13.24 13.9 28.028 30.461 21.378 8.522-3.422 16.91-10.302 26.237-11.072 13.439-1.109 23.118.463 36.008 5.492 24.917 9.722 25.023 50.418 8.35 67.83-29.186 30.481-75.005 28.443-111.245 14.62-22.156-8.451-42.701-21.298-55.568-41.583Z",
    style: {
      fill: "#518d64",
      fillOpacity: 1
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#484540",
    strokeLinecap: "square",
    strokeWidth: 4,
    d: "M-11.339 179.313c80.954 128.389 147.883-22.681 102.895-18.552-32.633 2.996-6.315 42.788 29.682 28.326 26.311-10.57 31.814-27.958 36.704-54.052 4.888-26.083 14.192-42.548 37.518-57.52 18.578-11.923 33.623-16.819 54.561-21.128"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken",
      fill: "#e6abab",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFBABA",
    d: "m187.158 390.977-100.342 1.17-1.206-100.305 134.14-10.509-32.592 109.644Z",
    style: {
      fill: "#e6abab",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken",
      fill: "#c1e4d1",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#A3FFE9",
    rx: 66.891,
    ry: 115.431,
    style: {
      fill: "#c1e4d1",
      fillOpacity: 1
    },
    transform: "matrix(-.83787 -.5464 .54658 -.83707 110.981 173.565)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 331.5,
    cy: 45.5,
    r: 2.5,
    fill: "#54E596"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDesktopLeft);
export default __webpack_public_path__ + "static/media/bg_desktop_left.662530d4c4ebe40c439fd3b95c1a2b05.svg";
export { ForwardRef as ReactComponent };